import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { Tiers } from "../../models/tiers.model";
import { TiersFacadeService } from "./tiers-facade.service";
import { StatsTiers } from "../../models/stats-tiers.model";

@Injectable({ providedIn: "root" })
export class TiersStoreService extends EntityStoreService<
  Tiers,
  EntityMetadata,
  TiersState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
      stats: null,
    });
  }
}

export interface TiersState extends EntityStoreState<TiersFacadeService> {
  stats: StatsTiers;
}
